import type { ReactNode } from "react";

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  tone?: "neutral" | "error";
}

export function EmptyState({ title, description, action, tone = "neutral" }: EmptyStateProps) {
  return (
    <div className="col-span-full text-center py-16 flex flex-col items-center gap-3">
      <p className={tone === "error" ? "text-red-500 font-medium" : "text-ink font-medium"}>{title}</p>
      {description && <p className="text-ink-muted text-sm max-w-sm">{description}</p>}
      {action}
    </div>
  );
}
